'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _reactI18next = require('react-i18next');

var _i18nextBrowserLanguagedetector = require('i18next-browser-languagedetector');

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

_i18next2.default
// load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
// learn more: https://github.com/i18next/i18next-xhr-backend
//.use(Backend)
// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use(_i18nextBrowserLanguagedetector2.default)
// pass the i18n instance to react-i18next.
.use(_reactI18next.initReactI18next)
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
  fallbackLng: 'zh-HK',
  debug: false,

  interpolation: {
    escapeValue: false // not needed for react as it escapes by default
  },
  resources: {
    // "en-US": {
    //   footer: FooterContentEn,
    //   header: FooterContentEn
    // },
    // "zh-CN": {
    //   footer: FooterContentCn,
    //   header: FooterContentCn 
    // },
    // "zh-HK": {
    //   footer: FooterContentCn,
    //   header: FooterContentCn 
    // },
    // "zh-TW": {
    //   footer: FooterContentCn,
    //   header: FooterContentCn 
    // }
  }
  // react: {
  //   bindI18n: 'added',
  //   bindI18nStore: 'added',
  //   useSuspense: true,
  // }
});

exports.default = _i18next2.default;